(() => {
  if (customElements.get('mobile-menu')) return;

  class MobileMenu extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.handleClose = this.handleClose.bind(this);
    }

    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      for (const accordion of this.querySelectorAll('[data-mobile-accordion]')) {
        accordion.addEventListener('toggle', () => this.handleToggle(accordion), { signal });
      }

      document.addEventListener('theme:sliderule:close', this.handleClose, { signal });

      const openTopLevelItem = this.querySelector(
        '[data-mobile-menu-level="0"] > [data-mobile-accordion][open]'
      );

      if (openTopLevelItem) {
        this.updateBanners(openTopLevelItem.parentElement.dataset.mobileMenuKey);
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    handleToggle(accordion) {
      const item = accordion.closest('[data-mobile-accordion-item]');
      const isTopLevel = item?.dataset.mobileMenuLevel === '0';

      if (accordion.open) {
        const switchedSibling = this.closeSiblings(accordion);

        if (isTopLevel) {
          this.updateBanners(item.dataset.mobileMenuKey);

          if (switchedSibling) {
            this.scrollItemToTop(item);
          }
        }

        return;
      }

      for (const childAccordion of accordion.querySelectorAll('[data-mobile-accordion][open]')) {
        childAccordion.open = false;
      }

      if (isTopLevel) {
        queueMicrotask(() => {
          const openTopLevelItem = this.querySelector(
            '[data-mobile-menu-level="0"] > [data-mobile-accordion][open]'
          );

          if (!openTopLevelItem) {
            this.updateBanners();
          }
        });
      }
    }

    closeSiblings(accordion) {
      const item = accordion.closest('[data-mobile-accordion-item]');
      const list = item?.parentElement;

      if (!list?.matches('[data-mobile-accordion-list]')) return false;

      let closedSibling = false;

      for (const sibling of list.children) {
        if (sibling === item || !sibling.matches('[data-mobile-accordion-item]')) continue;

        const siblingAccordion = sibling.querySelector(':scope > [data-mobile-accordion]');

        if (siblingAccordion?.open) {
          siblingAccordion.open = false;
          closedSibling = true;
        }
      }

      return closedSibling;
    }

    scrollItemToTop(item) {
      const scrollContainer = this.querySelector('.drawer__content__scroll');

      if (!scrollContainer) return;

      requestAnimationFrame(() => {
        const containerTop = scrollContainer.getBoundingClientRect().top;
        const itemTop = item.getBoundingClientRect().top;

        scrollContainer.scrollTo({
          top: Math.max(0, scrollContainer.scrollTop + itemTop - containerTop),
          behavior: 'smooth',
        });
      });
    }

    updateBanners(menuKey) {
      const target = this.querySelector('[data-mobile-menu-banners-target]');

      if (!target) return;

      const source = Array.from(document.querySelectorAll('[data-mobile-menu-banners]')).find(
        (template) => template.dataset.mobileMenuBanners === menuKey
      );

      target.replaceChildren();

      if (!source) {
        target.hidden = true;
        return;
      }

      target.append(source.content.cloneNode(true));
      target.hidden = false;
    }

    handleClose() {
      for (const accordion of this.querySelectorAll('[data-mobile-accordion][open]')) {
        accordion.open = false;
      }

      this.updateBanners();
    }
  }

  customElements.define('mobile-menu', MobileMenu);
})();
